// Détecteur CORS et basculement automatique vers mode hors ligne
// À ajouter au début de src/index.js

// 1. Intercepteur fetch global pour détecter les erreurs CORS
const originalFetch = window.fetch;
let corsErrorDetected = false;
let corsErrorCount = 0;

window.fetch = function(...args) {
    return originalFetch.apply(this, args)
        .catch(error => {
            // Détecter les erreurs CORS/réseau
            if (error.message.includes('CORS') ||
                error.message.includes('Failed to fetch') ||
                error.name === 'TypeError') {

                corsErrorCount++;
                corsErrorDetected = true;

                // Si plus de 2 erreurs CORS, déclencher le mode hors ligne automatique
                if (corsErrorCount >= 2) {
                    window.dispatchEvent(new CustomEvent('force-offline-due-to-cors'));
                }
            }

            // Re-lancer l'erreur pour que l'application puisse la gérer
            throw error;
        });
};

// 2. Intercepteur XMLHttpRequest pour Firebase
const originalXHR = window.XMLHttpRequest;
window.XMLHttpRequest = function() {
    const xhr = new originalXHR();
    const originalOpen = xhr.open;
    const originalSend = xhr.send;

    xhr.open = function(method, url, ...args) {
        this._url = url;
        return originalOpen.apply(this, [method, url, ...args]);
    };

    xhr.send = function(...args) {
        // Intercepter les erreurs CORS sur Firebase Auth
        this.addEventListener('error', function() {
            if (this._url && (
                this._url.includes('googleapis.com/identitytoolkit') ||
                this._url.includes('firestore.googleapis.com')
            )) {
                corsErrorDetected = true;
                corsErrorCount++;

                // Déclencher le mode hors ligne immédiatement
                setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('force-offline-due-to-cors'));
                }, 100);
            }
        });

        return originalSend.apply(this, args);
    };

    return xhr;
};

// 3. Gestionnaire d'événement pour basculement automatique
window.addEventListener('force-offline-due-to-cors', function() {

    // Obtenir l'email de l'utilisateur s'il est disponible
    let userEmail = null;
    try {
        // Essayer de récupérer l'email depuis localStorage
        const lastUser = localStorage.getItem('lastLoggedUser');
        if (lastUser) {
            const userData = JSON.parse(lastUser);
            userEmail = userData.email;
        }

        // Ou depuis l'élément email dans le formulaire
        const emailInput = document.querySelector('input[type="email"]');
        if (emailInput && emailInput.value) {
            userEmail = emailInput.value;
        }
    } catch (e) {
        // Ignore error when retrieving email
    }

    if (userEmail) {

        // Déclencher la connexion hors ligne
        window.dispatchEvent(new CustomEvent('auto-offline-login', {
            detail: { email: userEmail, reason: 'cors-detected' }
        }));
    } else {
        // Afficher un message à l'utilisateur
        setTimeout(() => {
            const message = document.createElement('div');
            message.innerHTML = `
                <div style="position: fixed; top: 20px; right: 20px; z-index: 10000; 
                            background: #f59e0b; color: white; padding: 15px 20px; 
                            border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); 
                            font-family: Arial, sans-serif; max-width: 400px;">
                    <strong>🚨 Problème de connexion CORS détecté</strong><br>
                    <p style="margin: 8px 0 0 0; font-size: 14px;">
                        Veuillez entrer votre email et essayer de vous connecter en mode hors ligne.
                    </p>
                    <button onclick="this.parentElement.remove()" 
                            style="position: absolute; top: 5px; right: 8px; 
                                   background: none; border: none; color: white; 
                                   cursor: pointer; font-size: 16px;">×</button>
                </div>
            `;
            document.body.appendChild(message);

            // Auto-suppression après 10 secondes
            setTimeout(() => {
                if (message.parentElement) {
                    message.remove();
                }
            }, 10000);
        }, 1000);
    }
});

// 4. Fonction utilitaire pour forcer la redirection
window.forceOfflineRedirect = function() {

    try {
        // Méthode 1: History API
        if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '/app');
            window.dispatchEvent(new PopStateEvent('popstate'));
            return;
        }
    } catch (e) {
        // Ignore History API error
    }

    try {
        // Méthode 2: window.location
        window.location.href = '/app';
    } catch (e) {
        // Méthode 3: replace
        window.location.replace('/app');
    }
};

// 5. Diagnostic CORS
window.diagnoseCORS = function() {
    return {
        corsErrorDetected,
        corsErrorCount,
        userAgent: navigator.userAgent,
        location: window.location.href,
        localStorage: !!window.localStorage,
        sessionStorage: !!window.sessionStorage
    };

    // Tester une requête simple
    fetch('/api/test')
        .then(() => {})
        .catch(e => {});
};

// Intercepteur CORS activé - Mode hors ligne automatique configuré
